/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupswindowtotal2Inputs */

const en_signupswindowtotal2 = /** @type {(inputs: Signupswindowtotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New in window`)
};

const de_signupswindowtotal2 = /** @type {(inputs: Signupswindowtotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu im Zeitraum`)
};

/**
* | output |
* | --- |
* | "New in window" |
*
* @param {Signupswindowtotal2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupswindowtotal2 = /** @type {((inputs?: Signupswindowtotal2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupswindowtotal2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupswindowtotal2(inputs)
	return de_signupswindowtotal2(inputs)
});
export { signupswindowtotal2 as "signupsWindowTotal" }